module.exports = react_stack;